import moment from "moment";
import type { ApiResponse } from "../models/ApiResponse";
import type { ProcessResponse } from "../models/ProcessResponse";
import type { UserInfo } from "../models/UserInfo";
import { getAxios } from "../helpers/api";
// import { AuthService } from "./AuthService";
import { config } from '../environments/environment'
import { number } from "yup";

class _AccountService {
    private localStorageKeys = {
        currentUser: "CURRENT_USER"
    }
    private baseUrl = config.url.PAYMENT_API;
  

    async GetAllAccounts(): Promise<any> {
        try {
            const res = await getAxios(this.baseUrl).get("/Account/get/all/accounts");
            var response = res.data as ApiResponse<any[]>;
            if (response.isSuccessful) {
                // if (response.data.dateOfBirth) response.data.dateOfBirth = moment(response.data.dateOfBirth).format('yyyy-MM-DD');

                return this.sortData(response.data);

            }
            return [];
        } catch (error) {
            
            return null;
        }
    }

    async GetAllAccountHistories(): Promise<any> {
        try {
            const res = await getAxios(this.baseUrl).get("/Account/get/all/accounthistories");
            var response = res.data as ApiResponse<any[]>;
            if (response.isSuccessful) {
                // if (response.data.dateOfBirth) response.data.dateOfBirth = moment(response.data.dateOfBirth).format('yyyy-MM-DD');

                return this.sortData(response.data);

            }
            return [];
        } catch (error) {
            
            return null;
        }
    }

    async GetAccountById(accountId: number): Promise<UserInfo | any> {
        try {
            const res = await getAxios(this.baseUrl).get(`/Account/get/account/by/id/${accountId}`);
            var response = res.data as ApiResponse<any>;
            if (response.isSuccessful) {
                if (response.data.dateCreated) response.data.dateCreated = moment(response.data.dateCreated).format('yyyy-MM-DD');
                return response.data;

            }
            return null;
        } catch (error) {
            return null;
        }
    }

    async GetAccountHistoryById(accountId: number): Promise<UserInfo | any> {
        try {
            const res = await getAxios(this.baseUrl).get(`/Account/get/accounthistories/by/accountId/${accountId}`);
            var response = res.data as ApiResponse<any>;
            if (response.isSuccessful) {
                if (response.data.dateCreated) response.data.dateCreated = moment(response.data.dateCreated).format('yyyy-MM-DD');
                return response.data;

            }
            return null;
        } catch (error) {
            return null;
        }
    }
   

    async AddNewAccount(accountTypeId:number,description: string,accountName:string,accountNumber:string,currentBalance:number,lastUpdatedByUserId:number,transactionNote:string): Promise<ProcessResponse> {
        try {

            const res = await getAxios(this.baseUrl).post("/Account/add/account", { accountTypeId,description,accountName,accountNumber,currentBalance,lastUpdatedByUserId,transactionNote });

            const data = res.data as ApiResponse<any>;
            if (data.isSuccessful) return { Successful: true, message: data.message };

            return { Successful: false, message: data.message ?? "Unable to Create Account. Please try again" }
        } catch (error) {

            return { Successful: false, message: "An error occurred. Please try again later" };
        }
    }

    async UpdateAccount(accountId:number,accountTypeId:number,description: string,accountName:string,accountNumber:string,currentBalance:number,lastUpdatedByUserId:number,transactionNote:string): Promise<ProcessResponse> {
        try {

            const res = await getAxios(this.baseUrl).post("/Account/update/account", {accountId, accountTypeId,description,accountName,accountNumber,currentBalance,lastUpdatedByUserId,transactionNote });

            const data = res.data as ApiResponse<any>;
            if (data.isSuccessful) return { Successful: true, message: data.message };

            return { Successful: false, message: data.message ?? "Unable to Create Account. Please try again" }
        } catch (error) {

            return { Successful: false, message: "An error occurred. Please try again later" };
        }
    }



    sortData(data:any[]) {
        let sortedData;
        sortedData = [...data].sort((a, b) => {
            return b.dateCreated.localeCompare(a.dateCreated);
        });
        return sortedData;
    }
 


}

export const AccountService = new _AccountService();
